import { render } from "./products.vue?vue&type=template&id=7b95f770&scoped=true"
import script from "./products.vue?vue&type=script&lang=js"
export * from "./products.vue?vue&type=script&lang=js"

import "./products.vue?vue&type=style&index=0&id=7b95f770&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b95f770"]])

export default __exports__